import { HttpInterceptorFn } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

async function computeHmacSignature(message: string, secretKey: string): Promise<string> {
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secretKey),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
  const signatureBuffer = await crypto.subtle.sign('HMAC', key, encoder.encode(message));
  return btoa(String.fromCharCode(...new Uint8Array(signatureBuffer)));
}

export const hmacInterceptor: HttpInterceptorFn = (req, next) => {
  const secretKey = environment.userAgentSecret;

  if (!secretKey) {
    return next(req);
  }

  const method = req.method;
  const baseUrl = environment.apiUrl;
  const requestUrl = req.urlWithParams.startsWith('http')
    ? new URL(req.urlWithParams)
    : new URL(req.urlWithParams, baseUrl);
  const path = requestUrl.pathname;
  const timestamp = Math.floor(Date.now() / 1000);
  const userAgent = environment.userAgent;
  const message = `${method}${path}${timestamp}${userAgent}`;

  return from(computeHmacSignature(message, secretKey)).pipe(
    switchMap((signature) => {
      const signed = req.clone({
        setHeaders: {
          'X-UserAgent': userAgent,
          'X-Timestamp': timestamp.toString(),
          'X-Signature': signature,
        },
      });
      return next(signed);
    })
  );
};
